<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示</div>
      <div class="tips-details">
        <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
        <div class="no">
          2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
        </div>
        <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
        <div class="no">
          4.域见未来单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
        </div>  
      </div>
    </div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">状态类型：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="searchObj.invoiceStatus"
            style="width: 150px"
            clearable
          >
            <Option
              v-for="item in invoiceStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 20px;">
          <div class="name" style="margin-right: 10px">交易时间：</div>
          <DatePicker
            class="bj-bg-color-26262A date-time-h45"
            v-model="searchObj.startAtStr"
            @on-change="handleChange"
            type="daterange"
            placeholder="请输入交易时间"
            style="width: 200px"
            clearable
          ></DatePicker>
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px;"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ searchObj.total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="{ row }">
          <span>{{ row.status | expressNumFilter }}</span>
        </template>
        <template slot="op" slot-scope="{ row }">
          <div class="bj-rows">
            <div class="table-btn" @click="toDetailsEvent(row.id)">详情</div>
            <div v-if="row.status < 3" class="table-btn" @click="cancelInvoiceEvent(row.id)">取消申请</div>
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { invoiceCancel, invoiceList } from "api/user.js";
export default {
  name: "invoice",
  filters: {
    expressNumFilter(val) {
      let title = "--";
      switch (val) {
        case 0:
          title = "未处理";
          break;
        case 1:
          title = "待审核";
          break;
        case 2:
          title = "待开票";
          break;
        case 3:
          title = "已开票";
          break;
        case 4:
          title = "待寄出";
          break;
        case 5:
          title = "已寄出";
          break;
        case 6:
          title = "审核未通过";
          break;
        case 7:
          title = "用户取消";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      invoiceStatusList: [
        {
          label: "未处理",
          value: 0,
        },
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待开票",
          value: 2,
        },
        {
          label: "已开票",
          value: 3,
        },
        {
          label: "待寄出",
          value: 4,
        },
        {
          label: "已寄出",
          value: 5,
        },
        {
          label: "审核未通过",
          value: 6,
        },
        {
          label: "用户取消",
          value: 7,
        },
      ],
      searchObj: {
        startAtStr: "",
        startAt: "",
        endAt: "",
        invoiceStatus: null,
        page: 1,
        limit: 20,
        total: 0,
      },
      columns: [
        {
          title: "发票金额",
          key: "amount",
          align: "center",
        },
        {
          title: "发票抬头",
          key: "header",
          align: "center",
        },
        {
          title: "申请时间",
          key: "createdTime",
          align: "center",
        },
        {
          title: "快递单号",
          key: "expressNum",
          align: "center",
        },
        {
          title: "状态",
          ellipsis: true,
          slot: "status",
          align: "center",
        },
        {
          title: "操作",
          ellipsis: true,
          slot: "op",
          align: "center",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created(){
    this.onPageChange(1);
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          end: this.searchObj.endAt,
          start: this.searchObj.startAt,
        };
        this.searchObj.invoiceStatus !== -1 &&
          (params.status = this.searchObj.invoiceStatus);
        this.tableLoading = true;
        const { code, data } = await invoiceList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 时间变化
    handleChange(val) {
      this.searchObj.startAtStr = val;
      if(val){
        this.searchObj.startAt = val[0];
        this.searchObj.endAt = val[1];
      }
    },
    // 取消申请
    cancelInvoiceEvent(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消申请此发票吗？</p>",
        onOk: async () => {
          let res = await invoiceCancel({ id });
          res = res.data;
          if (res.code === 200) {
            this.$Message.success("取消成功！");
            this.onPageChange(1);
          }
        },
      });
    },
    toDetailsEvent(id) {
      this.$router.push({ path: "/my/invoice/info", query: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.tips-section {
  background-color: #28292C;
  border-radius: 6px;
  display: flex;
  margin-top: 20px;
  .title {
    width: 80px;
    height: 160px;
    color: #fff;
    font-size: 16px;
    background-color: #4E312D;
    padding: 30px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .tips-details{
    padding: 28px 23px 10px;
    .no {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
    }
  }
}
.bj-search-section{
    background-color: #28292C;
    padding: 14px 28px;
    border-radius: 6px;
    margin-top: 30px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>
